var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.customFieldDefinitions && _vm.customFieldDefinitions.length > 0
    ? _c(
        "el-form",
        {
          staticClass: "custom-filter-container",
          attrs: { inline: "" },
          nativeOn: {
            submit: function($event) {
              $event.preventDefault()
            }
          }
        },
        [
          _c(
            "div",
            { staticStyle: { display: "flex", "flex-wrap": "wrap" } },
            _vm._l(_vm.customFieldDefinitions, function(definition) {
              return _c(
                "div",
                {
                  key: definition.path,
                  staticStyle: {
                    flex: "0 0 50%",
                    "box-sizing": "border-box",
                    padding: "5px"
                  }
                },
                [
                  _c("el-form-item", [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          display: "flex",
                          "align-items": "center"
                        }
                      },
                      [
                        _c("custom-field-label", {
                          staticStyle: { "margin-right": "10px" },
                          attrs: { "custom-field-definition": definition }
                        }),
                        _vm._v(" "),
                        definition.type ===
                        _vm.Custom_Field_Definition_Type.Date
                          ? [
                              _c("el-date-picker", {
                                attrs: {
                                  size: "mini",
                                  align: "right",
                                  "start-placeholder": _vm.$t("startDate"),
                                  format: "yyyy-MM-dd",
                                  "value-format": "yyyy-MM-dd"
                                },
                                on: { change: _vm.handleChange },
                                model: {
                                  value: _vm.selectedFilters[definition.path],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.selectedFilters,
                                      definition.path,
                                      $$v
                                    )
                                  },
                                  expression: "selectedFilters[definition.path]"
                                }
                              })
                            ]
                          : definition.type ===
                            _vm.Custom_Field_Definition_Type.String
                          ? [
                              _c("el-input", {
                                attrs: { size: "mini" },
                                on: { change: _vm.handleChange },
                                model: {
                                  value: _vm.selectedFilters[definition.path],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.selectedFilters,
                                      definition.path,
                                      $$v
                                    )
                                  },
                                  expression: "selectedFilters[definition.path]"
                                }
                              })
                            ]
                          : definition.type ===
                            _vm.Custom_Field_Definition_Type.Boolean
                          ? [
                              _c("el-checkbox", {
                                attrs: { size: "mini" },
                                on: { change: _vm.handleChange },
                                model: {
                                  value: _vm.selectedFilters[definition.path],
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.selectedFilters,
                                      definition.path,
                                      $$v
                                    )
                                  },
                                  expression: "selectedFilters[definition.path]"
                                }
                              })
                            ]
                          : _vm._e()
                      ],
                      2
                    )
                  ])
                ],
                1
              )
            }),
            0
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }